<div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill>
    <div fxFlex>
        <mat-toolbar color="primary">
            <span class="mat-h3 m-0" style="font-weight: 400">Aircraft Technical Logs</span>
            <span class="spacer"></span>
            <div style="margin-right: 20px; font-weight: lighter; font-size: medium">Select Aircraft</div>
            <mat-form-field style="height: 100%">
                <mat-select [(ngModel)]="selectedHelicopter" (selectionChange)="onHelicopterSelectChange($event)">
                    @for (item of helicopterOptions; track item) {
                        <mat-option [value]="item.value">{{ item.label }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </mat-toolbar>
    </div>
    <div fxFlex="calc(100vh - 130px)" fxLayout="row" fxLayoutAlign="center none" fxFlexFill>
        <div style="width: 240px; max-height: calc(100vh - 130px)">
            @if (!selectedBlockId) {
                <mat-nav-list role="navigation" class="p-0" style="flex-direction: column">
                    @for (block of blocksList; track block) {
                        <a
                            mat-list-item
                            [routerLink]="['./']"
                            [queryParams]="{ block: block.id }"
                            queryParamsHandling="merge"
                            [routerLinkActive]="'is-active'"
                            style="height: 72px"
                        >
                            <div fxLayout="row" style="padding-left: 5%">
                                <mat-icon mat-list-icon style="padding: 5%">folder</mat-icon>
                                <div style="padding-left: 5%">
                                    <div mat-line style="font-size: medium">Block Paper Nr.{{ block.serialNumber }}</div>
                                    <div mat-line style="font-size: small">
                                        <small>issued date</small>
                                        {{ block.issueDate | date: "dd-MM-yyyy" }}
                                    </div>
                                </div>
                            </div>
                        </a>
                    }
                </mat-nav-list>
            } @else {
                <div class="p-10" fxLayout="column" fxLayoutAlign="center center">
                    <h3 fxFlex class="mb-5">Block Paper Nr.{{ blockSerialNumber }}</h3>
                    <div fxFlex fxLayoutAlign="space-around center" style="width: 80%">
                        <a class="m-3" mat-raised-button color="primary" [routerLink]="['./']" [queryParams]="{ helicopter: selectedHelicopter }">
                            <mat-icon> keyboard_backspace </mat-icon>
                        </a>
                        <a class="m-3" mat-raised-button color="primary" style="width: 70%" [routerLink]="['/', helicopterString, 'blocks', 'update', selectedBlockId]"
                            >Edit block</a
                        >
                    </div>
                    <button
                        fxFlex
                        class="mt-5"
                        style="white-space: pre-wrap !important; width: 77%; padding: 10px"
                        fxLayout="row"
                        mat-raised-button
                        color="primary"
                        (click)="onOpenBlockNewTab()"
                    >
                        <mat-icon>download</mat-icon>Download all
                    </button>
                </div>
                <mat-divider class="mb-10"></mat-divider>
                <!--  -->
                <mat-accordion>
                    <mat-expansion-panel
                        (opened)="onExpansionPanelOpen('htlDocuments', true)"
                        (closed)="onExpansionPanelOpen('htlDocuments', false)"
                        [expanded]="expandHtlDocumentPanel"
                    >
                        <mat-expansion-panel-header>
                            <mat-panel-title> ATL Documents </mat-panel-title>
                        </mat-expansion-panel-header>
                        <mat-nav-list role="navigation" class="p-0" fxLayout="column" class="m-navlist">
                            @for (doc of htlDocuments; track doc) {
                                <div fxLayout="row" fxLayoutAlign="center center">
                                    <a
                                        fxFlex
                                        mat-list-item
                                        [routerLink]="['./']"
                                        [queryParams]="{ document: doc.htlDocumentId, holdItemList: null }"
                                        queryParamsHandling="merge"
                                        [routerLinkActive]="'is-active-sub'"
                                    >
                                        <div fxLayout="row" class="m-5">
                                            @if (canApprove && doc.isApproved) {
                                                <mat-icon
                                                    mat-list-icon
                                                    matTooltip="Approved by: {{ doc.approvedBy }} - {{ doc.approvedAt | date: 'dd/MM/YYYY HH:mm:ss' }}"
                                                    style="color: green"
                                                    >find_in_page</mat-icon
                                                >
                                            } @else {
                                                <mat-icon mat-list-icon>find_in_page</mat-icon>
                                            }
                                            <div mat-line style="margin-left: 5%; font-size: medium">Page Nr.{{ doc.pageNumber }}</div>
                                        </div>
                                        <!-- <div mat-line><small>flight date</small> {{doc.flightDate | date:'dd-MM-YYYY'}} </div> -->
                                    </a>
                                    <div matTooltip="Edited Document" fxFlex="25">
                                        @if (doc.isEdited) {
                                            <mat-icon>info</mat-icon>
                                        }
                                    </div>
                                </div>
                            }
                        </mat-nav-list>
                    </mat-expansion-panel>
                    <mat-expansion-panel
                        (opened)="onExpansionPanelOpen('holdItemList', true)"
                        (closed)="onExpansionPanelOpen('holdItemList', false)"
                        [expanded]="expandHoldItemListPanel"
                    >
                        <mat-expansion-panel-header>
                            <mat-panel-title> Hold item list </mat-panel-title>
                        </mat-expansion-panel-header>
                        @if (holdItemListUrl) {
                            <mat-nav-list role="navigation" class="p-0">
                                <div fxLayout="row" fxLayoutAlign="center center">
                                    <a
                                        fxFlex
                                        mat-list-item
                                        [routerLink]="['./']"
                                        [queryParams]="{ holdItemList: 'show', document: null }"
                                        queryParamsHandling="merge"
                                        [routerLinkActive]="'is-active-sub'"
                                    >
                                        <div fxLayout="row" class="m-5">
                                            <mat-icon mat-list-icon>text_snippet</mat-icon>
                                            <div mat-line style="margin-left: 5%; font-size: medium">Document</div>
                                        </div>
                                    </a>
                                    <button fxFlex="25" mat-icon-button color="primary" (click)="onOpenHoldItemListNewTab()">
                                        <mat-icon>cloud_download</mat-icon>
                                    </button>
                                </div>
                            </mat-nav-list>
                        }
                    </mat-expansion-panel>
                    <mat-expansion-panel (opened)="onExpansionPanelOpen('shortTerm', true)" (closed)="onExpansionPanelOpen('shortTerm', false)" [expanded]="expandShortTermPanel">
                        <mat-expansion-panel-header>
                            <mat-panel-title> Short Term / High Frequency </mat-panel-title>
                        </mat-expansion-panel-header>
                        @if (shortTermsListUrl) {
                            <mat-nav-list role="navigation" class="p-0">
                                <div fxLayout="row" fxLayoutAlign="center center">
                                    <a
                                        fxFlex
                                        mat-list-item
                                        [routerLink]="['./']"
                                        [queryParams]="{ shortTermsList: 'show', document: null }"
                                        queryParamsHandling="merge"
                                        [routerLinkActive]="'is-active-sub'"
                                    >
                                        <div fxLayout="row" class="m-5">
                                            <mat-icon mat-list-icon>text_snippet</mat-icon>
                                            <div mat-line style="margin-left: 5%; font-size: medium">Document</div>
                                        </div>
                                    </a>
                                    <button fxFlex="25" mat-icon-button color="primary" (click)="onOpenShortTermsListNewTab()">
                                        <mat-icon>cloud_download</mat-icon>
                                    </button>
                                </div>
                            </mat-nav-list>
                        }
                    </mat-expansion-panel>
                </mat-accordion>
            }
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div fxFlex fxLayout="column" fxLayoutAlign="space-evenly stretch" style="height: auto">
            @if (selectedHtlDocumentId) {
                <div fxFlex fxLayout="column" style="min-height: 220px !important">
                    <div fxFlex fxLayout="row">
                        @if (isEditedDocument) {
                            <button
                                #anchor
                                kendoButton
                                [themeColor]="'primary'"
                                (click)="viewHistory()"
                                style="
                                    margin: 14px;
                                    margin-right: 0;
                                    height: fit-content;
                                    padding: 10px;
                                    color: white;
                                    background-color: #3f51b5;
                                    font-size: 13px;
                                    font-weight: 500;
                                    border-radius: 5px;
                                    border-color: #3f51b5;
                                    font-family: Roboto, sans-serif;
                                "
                            >
                                View History
                            </button>
                            @if (showHistoryPopup) {
                                <kendo-popup [anchor]="{ nativeElement: anchor.nativeElement }" (anchorViewportLeave)="showHistoryPopup = false">
                                    <div style="padding: 6px">
                                        @for (note of notes; track $index) {
                                            <div style="font-size: small">
                                                {{ note.savedAt | date: "dd-MM-yyyy HH:mm" }}:
                                                {{ note.notes }}
                                            </div>
                                        }
                                    </div>
                                </kendo-popup>
                            }
                            <div style="margin: 10px; margin-top: 22px; font-size: medium !important; max-width: 53%">
                                Note ({{ notes[0]?.savedAt | date: "dd-MM-yyyy HH:mm" }}):
                                {{ notes[0]?.notes }}
                            </div>
                        }
                        @if (!editQtb) {
                            <div style="height: 60px; margin-right: 0px; margin-left: auto; margin-top: 10px" fxLayoutAlign="center center">
                                <div style="float: right">
                                    <div matTooltip="Editing allowed only on previous closed signed pages" [matTooltipDisabled]="hasSignature">
                                        <button style="margin: 5px; font-size: small" mat-raised-button color="primary" (click)="onOpenDocumentPDFNewTab()">Show Pdf</button>
                                        @if (isEditedDocument) {
                                            <button style="margin: 5px; font-size: small" mat-raised-button color="primary" (click)="onOpenDocumentNewTab()">Show original</button>
                                        }
                                        @if (isSuperUser) {
                                            <button
                                                style="margin: 5px; font-size: small"
                                                mat-raised-button
                                                color="primary"
                                                [disabled]="!hasSignature"
                                                (click)="onEditButtonClick()"
                                            >
                                                Edit document
                                            </button>
                                        }
                                        @if (isSuperUser && canApprove) {
                                            <button
                                                style="margin: 5px; font-size: small"
                                                mat-raised-button
                                                color="primary"
                                                [disabled]="!hasSignature || documentApproved"
                                                (click)="approveDocument()"
                                            >
                                                Approve
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <app-edit-qtb
                        #editqtbtable
                        style="height: calc(100vh - 200px)"
                        [blockID]="selectedBlockId"
                        [helicopterID]="selectedHelicopter"
                        [documentID]="selectedHtlDocumentId"
                        (getOriginalPdfPath)="getOriginalPdfPath($event)"
                        (getCurrentPdfPath)="getCurrentPdfPath($event)"
                        (getNotes)="getNotes($event)"
                        (setEditQtb)="updateEditing($event)"
                        (onSaveEvent)="onSpreadsheetSave()"
                    >
                    </app-edit-qtb>
                </div>
            }
            @if (holdItemListUrl) {
                <pdf-viewer [src]="holdItemListUrl" [render-text]="true" [original-size]="false" [fit-to-page]="true" style="display: block; width: 100%; height: 100%">
                </pdf-viewer>
            }
            @if (shortTermsListUrl) {
                <pdf-viewer [src]="shortTermsListUrl" [render-text]="true" [original-size]="false" [fit-to-page]="true" style="display: block; width: 100%; height: 100%">
                </pdf-viewer>
            }
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
